// src/hooks/nationalities/useForceDeleteAllNationalities.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllNationalities as forceDeleteAllNationalitiesAPI } from "../../api/apiNationalities";
import parseError from "../../utils/parseError";

const useForceDeleteAllNationalities = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAll, isPending: isForceDeleteAll } = useMutation({
        mutationFn: forceDeleteAllNationalitiesAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected nationalities permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["nationalities"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete selected nationalities");
        },
    });

    return { forceDeleteAllNationalities: forceDeleteAll, isForceDeleteAll };
};

export default useForceDeleteAllNationalities;